import React from 'react'
import { Skeleton } from '@fs/zion-ui'

const PageLoading = (): JSX.Element => {
  return <Skeleton.Image width="100%" height="100vh" />
}

export default PageLoading
